import React from "react";

const FilterRadioList = () => {
    return <h1>Filter Radio List</h1>;
};
export default FilterRadioList;
